import brand from '@helpers/brand';
import { siteWide } from '@helpers/grid';
import styled, { css } from 'styled-components';
export const ThemeDefaults = css `
  // Defaults //
  --sectionBackgroundColor: ${brand.primary.white};
  --sectionForegroundColor: ${brand.primary.darkBlue};

  &[data-theme='light-blue'] {
    --sectionBackgroundColor: ${brand.secondary.paleBlue};
    --sectionForegroundColor: ${brand.primary.darkBlue};
  }

  &[data-theme='dark-blue'] {
    --sectionBackgroundColor: ${brand.primary.darkBlue};
    --sectionForegroundColor: ${brand.primary.white};
  }

  &[data-theme='grey'] {
    --sectionBackgroundColor: ${brand.grey.light};
    --sectionForegroundColor: ${brand.primary.darkBlue};
  }

  background-color: var(--sectionBackgroundColor, unset);
  color: var(--sectionForegroundColor, ${brand.secondary.black});
`;
const Container = styled.section `
  scroll-margin: var(--headerHeight) 0 0;

  [data-has-in-page-navigation='true'] & {
    scroll-margin-top: calc(var(--headerHeight) + var(--inPageNavigationHeight, 66px) - 15px);
  }

  &[data-flush='top'] {
    --sectionSpacingTop: 0;
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;
  }

  ${ThemeDefaults}
`;
const Inner = styled.div `
  ${siteWide};

  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);
`;
const SectionWrapperStyles = {
    Container,
    Inner,
};
export default SectionWrapperStyles;
